import React, { Component } from 'react';
import PropTypes from 'prop-types';
import style from './style';
import { path, clone } from 'ramda';
import { deteteById, getLastId } from '../../utils/arrObj';

export default class DynamicFormList extends Component {

  constructor(props) {
    super(props);
    this.renderList = this.renderList.bind(this);
    this.addListItem = this.addListItem.bind(this);
    this.getRemoveAllButtom = this.getRemoveAllButtom.bind(this);
    this.renderListItem = this.renderListItem.bind(this);
    this.renderListItemContainer = this.renderListItemContainer.bind(this);
    this.getListName = this.getListName.bind(this);
    this.changeList = this.changeList.bind(this);
    this.removeAllItems = this.removeAllItems.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  changeList(list) {
    const field = path(['fields', '_system', 'relatedTo'], this.props);
    this.props.onChange(field, list);
  }

  renderListItem(items) {
    const listItemContainer = [];
    const fieldTo =  path(['fields', '_system', 'relatedTo'], this.props);
    let counter = 0;
    for (let item in items) {
      if (item === 'id' || item === 'name') {
        continue;
      }

      let currentItem = items[item];
      const Component = path(['system', 'component'], currentItem);

      if (!Component) {
        continue;
      }
      listItemContainer.push(
        <span key={counter++}>
          <Component
            options={this.props.options}
            disabled={this.props.disabled}
            relatedTo={fieldTo}
            field={currentItem}
            onChange={this.props.onChange}
          />
        </span>
      );
    }

    return listItemContainer;
  }

  renderListItemContainer(id, children) {
    return (
      <div className="dynamic-list-item" style={style.box} key={id}>
        {!this.props.disabled && <button
          className={'btn btn-danger btn-outline float-right'}
          style={{
            position: 'relative',
            top: '-15px',
            left: '0px',
          }}
          onClick={(e) => {
            this.removeItem(e, id);
          }}
        >
          <i className="fa fa-remove"></i>
        </button>
        }
        <div style={{
          paddingTop: '25px',
        }}>
          {children}
        </div>
      </div>
    );
  }

  removeItem(e, id) {
    e.preventDefault();

    let listClone = clone(this.props.list);
    // Remove
    const elForRemove = listClone.filter((el) => id === el.id);
    if (this.props.idsForRemote && elForRemove) {
      this.props.idsForRemote.push(elForRemove[0]);
    }
    listClone = deteteById(
      id,
      listClone
    );

    this.changeList(listClone);
  }

  renderList() {
    const list = path(['list'], this.props);
    const listContainer = [];

    const onRenderListItem = this.props.onRenderListItem
      ? this.props.onRenderListItem
      : this.renderListItem;

    for (let i = 0; i < list.length; i++) {
      listContainer.push(this.renderListItemContainer(list[i].id, onRenderListItem(list[i])));
    }

    return listContainer;
  }

  addListItem(e) {
    e.preventDefault();
    let listClone = clone(this.props.list);
    let id = getLastId(listClone) + 1;
    let itemTemplate = clone(this.props.fields);
    // Set new summary
    itemTemplate.id = id;
    delete itemTemplate._system;
    listClone.push(itemTemplate);

    this.changeList(listClone);
  }

  removeAllItems(e) {
    e.preventDefault();
    let listClone = clone(this.props.list);
    listClone = [];
    if (this.props.idsForRemote) {
      for (let item of this.props.list) {
        this.props.idsForRemote.push(item);
      }
    }
    this.changeList(listClone);
  }

  getRemoveAllButtom() {
    if (!path(['list', 'length'], this.props)) {
      return null;
    }
    return (
      <button
        className={'btn btn-danger btn-outline float-right'}
        style={{ marginLeft: '10px' }}
        onClick={this.removeAllItems}
      >
        <i className="fa fa-remove"></i>
        <span style={{ paddingLeft: '3px' }}>Remove All</span>
      </button>
    );
  }

  getListName() {
    const name = path(['fields', '_system', 'name'], this.props);
    return name || null;
  }

  render() {
    return (
      <div className="card rounded mb-3">
        <div className="card-header rounded-top">
          {this.getListName()}
        </div>
        <div className="card-block">
          <div className="row">
            <div className="col col-lg-12 pull-right">
              {!this.props.disabled && this.getRemoveAllButtom()}
              {!this.props.disabled && <button className={'btn btn-success btn-outline float-right'} onClick={this.addListItem}>
                <i
                  className="material-icons material-icons"
                  style={{
                    top: '2px',
                    position: 'relative',
                    fontSize: '13px',
                  }}
                >add_circle</i>
                <span style={{ paddingLeft: '3px' }}>Add</span>
              </button>
              }
            </div>
            <div className="col col-lg-12">
              {this.renderList()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DynamicFormList.propTypes = {
  list: PropTypes.array,
  idsForRemote: PropTypes.array,
  fields: PropTypes.object,
  onChange: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/common/DynamicFormList/index.js